import { t as translate } from "./preferences";
import type { LucideIcon } from "lucide-react";
import {
  BarChart3,
  Boxes,
  BriefcaseBusiness,
  CircleUserRound,
  Clock3,
  Headphones,
  House,
  UsersRound,
  CarFront,
} from "lucide-react";

export type RouteCapability = "general" | "usta" | "warehouse" | "account";

export type AppRoute = {
  path: string;
  title: string;
  description: string;
  capability: RouteCapability;
  icon: LucideIcon;
  bottomNav?: boolean;
};

export const APP_ROUTES: readonly AppRoute[] = [
  {
    path: "/mechanic/",
    get title() { return translate("Bosh sahifa"); },
    description: "Kunlik ishlar uchun bosh ekran shu yerda bo‘ladi.",
    capability: "general",
    icon: House,
    bottomNav: true,
  },
  {
    path: "/mechanic/history",
    get title() { return translate("Tarix"); },
    description: "Bajarilgan ishlar tarixi keyingi bosqichda qo‘shiladi.",
    capability: "general",
    icon: Clock3,
    bottomNav: true,
  },
  {
    path: "/mechanic/statistics",
    get title() { return translate("Statistika"); },
    description: "Shaxsiy natijalar va davrlar kesimi keyingi bosqichda keladi.",
    capability: "general",
    icon: BarChart3,
    bottomNav: true,
  },
  {
    path: "/mechanic/clients",
    get title() { return translate("Mijozlar"); },
    description: "Mijoz qidiruvi va kartochkalari hali ulanmagan.",
    capability: "general",
    icon: UsersRound,
  },
  {
    path: "/mechanic/vehicles",
    get title() { return translate("Avtomobillar"); },
    get description() { return translate("Ustaxona avtomobillari."); },
    capability: "general",
    icon: CarFront,
  },
  {
    path: "/mechanic/work",
    get title() { return translate("Ish"); },
    get description() { return translate("Yangi ish, to‘lov va eslatma yaratish."); },
    capability: "usta",
    icon: BriefcaseBusiness,
  },
  {
    path: "/mechanic/warehouse",
    get title() { return translate("Ombor"); },
    get description() { return translate("Filial zaxirasi, sotuv va ombor amallari."); },
    capability: "warehouse",
    icon: Boxes,
  },
  {
    path: "/mechanic/support",
    get title() { return translate("Yordam"); },
    description: "Shaxsiy murojaatlar oqimi keyingi bosqichda qo‘shiladi.",
    capability: "account",
    icon: Headphones,
  },
  {
    path: "/mechanic/profile",
    get title() { return translate("Profil"); },
    description: "Profil sozlamalari va sessiya boshqaruvi shu yerda bo‘ladi.",
    capability: "account",
    icon: CircleUserRound,
    bottomNav: true,
  },
] as const;

export function routeByPath(pathname: string): AppRoute | undefined {
  return APP_ROUTES.find((route) =>
    route.path === pathname ||
    (route.path !== "/mechanic/" && pathname.startsWith(`${route.path}/`)),
  );
}
